import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/PRINCEWILL SUIT - AI Automation Practice Lead.png";
import OmobosolaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.png";
import RachaelImage from "../../../../../assets/images/png/courses/instructors/rachael.webp";
import DoluImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import BackendPreview from "../../../../../assets/images/jpeg/softwarePreview.jpeg";

export const backendProgrammingAfrica = {
  id: 1,
  tag: "FOR EXPERIENCED PROFESSIONALS",
  title: "Backend Development Bootcamp",
  seoTitle: "Backend Development Bootcamp",
  description: `
  Go from zero knowledge to being able to build your technology 
  platforms! Starting with the foundations of software engineering. 
  By the end of this program you would have mastered a specialization and 
  learn the art of effective collaboration to solve real world problems.
    `,
  duration: "8 Weeks",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1vCK9FxUXnohLSxUZOYySAYd7KX4N5eFj/view?usp=sharing",

  courseFormUrl: "courses/backend-development/fill-form",

  jobTitle: "Backend Developer",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Friday 4:00 PM - 7:00 PM WAT
      <br />
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    // image: TestimonialImage,
    name: "Adetunji J.",
    role: "Backend Engineer",
    testimony: `
    I was looking for something a little more than a training, a school I 
    could count on for my continuous skill and professional development. 
    Utiva kept coming up so I jumped in. I went through the Backend Program.
    I am now a Backend engineer.`,
    starRating: "5.0",
    date: "August 2021",
  },

  courseOverview: {
    title: `Throughout the course, we will explore the most important technologies 
    and concepts you need to know to become a market-ready developer.`,
    desc: `
    Throughout the course, we will explore the most important 
    technologies and concepts you need to know to become a market-ready 
    developer. This course is designed for individuals who want to be 
    backend developers. You will learn all the fundamentals about 
    backend development. With this course, you will learn how to build 
    secure, fast, scalable, documented and well tested websites. 
    Whether you are total beginner looking for a full packaged backend 
    development program, or you are programmer/web developer looking to 
    improve your design skills, or maybe a designer looking to learn how 
    to code, this course takes you step-by-step through all of the necessary skills you 
    need to know to start working professionally as a web designer or developer.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Software Development Fundamentals",
      unitTag: "Fundamental",
      unitDescription: `
      An introductory session that develops your thought-process on the fundamentals 
      of programming and software engineering principles.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Walkthrough",
          featureDescription: `We will walk you through the principles that guide software development at scale.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Practice",
          featureDescription: `You will augment your previously developed static site by adding 
          multiple pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "API",
          featureDescription: `You’ll create your own API to add further functionality to front-end applications.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Database",
          featureDescription: `You will build out the functionality of an application by 
            collecting and storing complex data in your own database.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Node",
      unitTag: "Express, Clients",
      unitDescription: `
      Learn how websites interact with a back-end to exchange application data. 
      Using Node.js, a JavaScript environment, and Express, a Node framework, 
      you’ll learn how to quickly leverage back-end technologies to create a 
      full-stack application. By understanding how to create your own application 
      programming interface (API), you’ll be able to customize and improve the functionality of your work.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Plan",
          featureDescription: `Develop a plan for how you would tackle the analysis of a business problem.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Examine the problem",
          featureDescription: `Begin examining a business problem, by using Excel to clean, 
                analyze and visualize data to identify trends and gather insights.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Querying",
          featureDescription: `Apply SQL by querying a relational database to bring data 
            to the surface. You will manipulate data using SQL to draw insights.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Visualization",
          featureDescription: `Use Power BI to develop visualizations and dashboards. Prepare a compelling 
                narrative surrounding your data analysis and present your visualizations.`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Databases",
      unitTag: "MySQL, Database Structures",
      unitDescription: `
      Understanding different database structures is critical in managing 
      large amounts of information in an efficient and effective way. 
      To store and manage data, you’ll learn how to use MySQL, a 
      high-performance, open-source relational database management 
      system used by data-rich companies like YouTube, Netflix, and Spotify.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Plan",
          featureDescription: `Develop a plan for how you would tackle the analysis of a business problem.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Examine the problem",
          featureDescription: `Begin examining a business problem, by using Excel to clean, 
                    analyze and visualize data to identify trends and gather insights.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Querying",
          featureDescription: `Apply SQL by querying a relational database to bring data 
                to the surface. You will manipulate data using SQL to draw insights.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Visualization",
          featureDescription: `Use Power BI to develop visualizations and dashboards. Prepare a compelling 
                    narrative surrounding your data analysis and present your visualizations.`,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Princewill Ogbu",
      coachRole: "AI Automation Practice Lead",
    },
    {
      coachId: 2,
      coachImage: RachaelImage,
      coachName: "Rachael Wilson",
      coachRole: "Senior Data Analyst",
    },
    {
      coachId: 3,
      coachImage: DoluImage,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 4,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
    {
      coachId: 5,
      coachImage: OmobosolaImage,
      coachName: "Omobosola Olafimihan",
      coachRole: "AI Automation Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learning Model",
      modelDescription:
        "A 8 Weeks experiential learning and hands-on training session.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Training Methodology",
      modelDescription: "Learn through real-life problems",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-Focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Access Contents & Materials",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: null,
      firstname: "James",
      lastname: "A.",
      company: "Backend Dev Fellow",
      testimony: `
      Utiva has impacted my career progression in a 
      positive way as the changes in the last couple of months have 
      been rapid. I've had to change roles from a business-oriented role 
      to a digital-oriented role. I've had opportunities to implement 
      my learnings in real life scenarios, had a role change to a developer role, scholarships 
      and also volunteering roles. I feel fulfilled implementing my passion.  
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases ",
    description: `
    Present everything you've learned with a real-world capstone project. 
    Every week in your backend development classes, you'll be provided 
    with clear actionable steps to iteratively develop your project. 
    By the end of the course, you will have implemented each step of 
    the process, leveraging your knowledge of Javascript, NodeJS, and database
    to develop and derive a comprehensive solution of your work.
      `,
    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Backend Development Certification",
    description: `
    Upon completing Utiva's Backend Development Course, you'll 
    receive an industry-recognized, professional Backend Development 
    certification to share with your network and showcase all that 
    you've learned. Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",
  videoTestimonial: "https://www.youtube.com/embed/ArxnT-7wAg4",
  videoPreviewImage: BackendPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Become a Full-Stack Developer",
      courseDescription: `Go from zero knowledge to being able to build your technology platforms! Starting with 
      the foundations of software engineering. By the end of this program you 
      would have mastered a specialisation and learn the art of effective 
      collaboration to solve real world problems.`,
      courseUrl: "/courses/fullstack-development",
    },
    {
      id: 2,
      courseTitle: "Become a Frontend Developer",
      courseDescription: `You’ll learn all you need to know and build the capacity to handle
       projects with an interesting portfolio as a frontend developer with a 
      coaching program that focuses on fundamentals of HTML, CSS, JavaScript and React..`,
      courseUrl: "/courses/frontend-development",
    },
  ],
};
